import BasePage from '../../components/base-page/base-page';
import Carousel from '../../components/carousel/carousel';

import breakpoints from '../../config/breakpoints';

import type { UiElement } from '../../../shared/ui-element/ui-element';

import './affiliate-program.scss';


class AffiliateProgramPage extends BasePage {
  ui = {
    testimonialsCarousel: '.js-testimonials-carousel',
  };

  testimonialsCarousel = new Carousel({
    rootElement: this.ui.testimonialsCarousel,
    slidesPerPage: {
      [breakpoints.sm]: 2,
      [breakpoints.lg]: 3,
    },
  });

  onInit() {
    super.onInit();
    this.testimonialsCarousel.init();
  }
}

export default AffiliateProgramPage;

(AffiliateProgramPage as UiElement).initOnDomLoaded();
